import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "full-width q-pb-sm row items-center" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-error-70"
}

interface IProps {
  required?: boolean
  label?: string
  description?: string
  calloutTitle?: string
  calloutDescription?: string
  descriptionColor?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KExternalLabel', inheritAttrs: false },
  __name: 'KExternalLabel',
  props: {
    required: { type: Boolean, default: false },
    label: { default: '' },
    description: { default: '' },
    calloutTitle: { default: '' },
    calloutDescription: { default: '' },
    descriptionColor: { default: '' }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_KCallout = _resolveComponent("KCallout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "before"),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("label", _mergeProps({
        for: _ctx.$attrs['for'] ? (_ctx.$attrs['for'] as string) : undefined,
        class: "fs-15px fw-500 text-cool-gray-80"
      }, _ctx.$attrs), _toDisplayString(__props.label), 17, _hoisted_2),
      (__props.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.required ? ' *' : ''), 1))
        : _createCommentVNode("", true),
      (__props.calloutDescription)
        ? (_openBlock(), _createBlock(_component_KCallout, {
            key: 1,
            title: __props.calloutTitle,
            description: __props.calloutDescription,
            "container-class": "q-ml-xs"
          }, null, 8, ["title", "description"]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "after"),
    _renderSlot(_ctx.$slots, "description", {}, () => [
      (__props.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["fs-13px fw-400 block full-width", [__props.descriptionColor ? `text-${__props.descriptionColor}` : 'text-cool-gray-70']])
          }, _toDisplayString(__props.description), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})